export default "__VITE_ASSET__B43bQ_a5__"